import { toast } from "react-toastify";
import getCardDetail from "./getCardDetails";

interface ParamsType {
  cardnumberElement: any;
  stripe: any;
  elements: any;
  clientSecret: string;
  email: string;
  customerId?: string;
  setCardDetails?: (params: any) => void;
  setIsProcessing?: (params: any) => void;
  stripId: string;
  cardcvv: any;
  cardExpiry: any;
  setShowModel?: (params: any) => void;
  onCheckModel?: any;
  setSubmitError?: (msg: string | null) => void;
  setHighlightAllErrors?: (value: boolean) => void;
}

const addCreditCard = async (params: ParamsType) => {
  if (!params?.stripe || !params?.elements) {
    console.error("Stripe or elements is not loaded");
    return;
  }
  if (!params?.cardnumberElement) {
    console.error("CardNumberElement is not available");
    return;
  }
  const { setupIntent, error } = await params?.stripe.confirmCardSetup(
    params?.clientSecret,
    {
      payment_method: {
        card: params?.cardnumberElement,
        billing_details: { email: params?.email },
      },
    }
  );

  if (error) {
    console.error("setupIntent error", error);
    toast.error(error.message);
    params?.setSubmitError?.(
      "The card information you've entered is not correct. Please verify that the information is correct and try again."
    );
    params?.setHighlightAllErrors?.(true);
    params?.setIsProcessing(false);
    return;
  }
  if (setupIntent?.status === "succeeded") {
    console.log("setupIntent", setupIntent);

    toast.success("Card Added Successfully");
    params?.cardnumberElement?.clear();
    params?.cardExpiry?.clear();
    params?.cardcvv?.clear();
    getCardDetail({
      setIsProcessing: params?.setIsProcessing,
      setCardDetails: params?.setCardDetails,
      // customerId: params?.stripId,
    });
    params?.setIsProcessing(false);
    if (params?.onCheckModel) params?.onCheckModel();
    if (params?.setShowModel) params?.setShowModel(false);
  }
};
export default addCreditCard;
